import styles from './styles.module.scss'
import classNames  from 'classnames'
import { Icon } from '../../ui/icons/Icon'
import { useEffect, useState } from 'react'
import {useSelector, useDispatch} from 'react-redux'
import { ENV_JS } from '../../../utils/env_module'
import { SET_VARIABLES } from '../../../redux/types'

export const useMessage = () => {
  const REDUCER_DISPASH = useDispatch()
  const clientDataReducer = useSelector(state => state.clientDataReducer)
  const variablesReducer = useSelector(state => state.variablesReducer)
  const [showCitationsBlock, setShowCitationsBlock] = useState(false)
  const [citationContent, setCitationContent] = useState('')
  const [citationTextTarget, setCitationTextTarget] = useState()
  const [currentSiteId, setCurrentSiteId] = useState(null)
  const CALLPY_STORAGE_NAME = ENV_JS?.CALLPY_STORAGE_NAME??null
  if(!CALLPY_STORAGE_NAME) return []

  const [showSelectedMessagesBlock, setShowSelectedMessagesBlock] = useState(false)
  const [selectedMessagesContent, setSelectedMessagesContent] = useState('')
  const [selectedMessagesCounter, setSelectedMessagesCounter] = useState(1)


  /*========> START CITATION <============*/
  const handlerRemoveCitation = () => {
    setShowCitationsBlock(false)
    setCitationContent('')
    REDUCER_DISPASH({type: SET_VARIABLES, payload:{selectedMessageId:null, citationTextTarget:null}})
  }

  const startCitation = (opt={}) => {
    const {userName, text, messageId} = opt
    if(userName&&text&&messageId) {
      //console.log('text', text, opt)
      const box = (
        <div className={classNames(styles.partialCitation)}>
          <div className={classNames(styles.partialCitationInner)}>
            <span className={classNames(styles.partialCitationIcon)}><Icon name="quotes"/></span>
            <div className={classNames(styles.partialCitationBody)}>
              <div className={classNames(styles.partialCitationAuthor)}>{userName}</div>
              <div className={classNames(styles.partialCitationText)}>{text}</div>
            </div>
            <button className={classNames(styles.partialCitationCloseBtn)} onClick={handlerRemoveCitation} data-close-w="false"><Icon name="close" size="16px" hoverBg="#E6402E"/></button>
          </div>
        </div>
      )
      setCitationTextTarget(text)
      setCitationContent(box)
      setShowCitationsBlock(true)
      setSelectedMessagesCounter(current => current+1)
      //setCitationMssageId(messageId)
    }
  }

  const citationsBlock =  (
    showCitationsBlock
    &&
    <div className={classNames(styles.citationsBlock)}>
      {citationContent}
    </div>
  )

  const closeCitation = () => {
    handlerRemoveCitation()
    setCitationTextTarget(null)
  }

  const sendMessage = (opt={}, callback, setShowCitationsBlock) => {
    const {message, messageType, additionalData, selectedMessageId, citationTextTarget} = opt
    const options = {}
    const citationMssageId = selectedMessageId??null
    
    console.log('message>>1', message, citationMssageId, citationTextTarget, new Date().getTime())
    if(message?.length) {
      options.message = message
      
      if(citationMssageId){
        if(currentSiteId) {
          //console.log('message>>2', message, citationMssageId, {[citationMssageId]:citationTextTarget})
          options.messageType = messageType??8
          options.additionalData = additionalData??{
            messagesIds: [citationMssageId],
            attached_site_id: currentSiteId,
            //attached_dialog_id: '',
            messagesIds_text: {[citationMssageId]:citationTextTarget},
            jsTime: new Date().getTime()
          }
        }
      }
      //console.log('citationMssageId', citationMssageId, currentSiteId)
      const _callback = (response) => {
        if(callback) callback(response)
      }
      options.callback = _callback

      //console.log('message>>1', message, options)

      window?.m_callpy?.m_chat?.send_message_click(options)


      const storage = JSON.parse(localStorage.getItem(CALLPY_STORAGE_NAME))??null
      if(storage) {
        const emojis = storage?.emojis??null
        const theMostUsed = emojis?.theMostUsed??[]
        const live = emojis?.live??null
        if(live) {
          for (let i = 0; i < live.length; i++) {
            const existEmoji = theMostUsed.find(item=>item.id===live[i].id)
            if(existEmoji) {
              existEmoji.count += live[i].count
            } else {
              theMostUsed.push(live[i])
            }
          }
          live.length=0
        }
        localStorage.setItem(CALLPY_STORAGE_NAME, JSON.stringify(storage))
      }

      if(showCitationsBlock) closeCitation ()
      
    }
  }

  useEffect(() => {
    if(clientDataReducer?.site_id) {
      const sitId = clientDataReducer.site_id
      setCurrentSiteId(sitId)
    }
  }, [clientDataReducer.site_id])

  /*========> END CITATION <============*/
 



  /*========> START SELECTION <============*/
  const selectionBlock = (
    showSelectedMessagesBlock
    &&
    <div className={classNames(styles.selectionBlock)}>
      {selectedMessagesContent}
    </div>
  )

  const startSelection = (opt={}, callback) => {
    console.log('option', opt)
    const box = (
      <div className={classNames(styles.selectionControl)}>
        <div className={classNames(styles.selectionControlInner)}>
          <button className={classNames(styles.selectionControlCloseBtn)} onClick={handlerRemoveCitation} data-close-w="false"><Icon name="close" size="20px" bg="#4A5A62" hoverBg="#E6402E"/></button>
          <span className={classNames(styles.selectionControlCounter)}>{selectedMessagesCounter}</span>
          <div className={classNames(styles.selectionControlActions)}>
            {
              (selectedMessagesCounter>1)&&
              <>
                <button className={classNames(styles.selectionControlActionsBtn)} data-close-w="false"><Icon name="resend" size="20px" bg="#4A5A62"/></button>
                <button className={classNames(styles.selectionControlActionsBtn)} data-close-w="false"><Icon name="edit" size="20px" bg="#4A5A62"/></button>
              </>
            }
            
            <button className={classNames(styles.selectionControlActionsBtn)} data-close-w="false"><Icon name="copy" size="20px" bg="#4A5A62"/></button>
            <button className={classNames(styles.selectionControlActionsBtn)} data-close-w="false"><Icon name="delete2" size="20px" bg="#E6402E" hoverBg="#E6402E"/></button>
          </div>
        </div>
      </div>
    )

    setSelectedMessagesContent(box)
    if(!showSelectedMessagesBlock) setShowSelectedMessagesBlock(true)
  }
  /*========> END SELECTION <============*/



  return {
    citationsBlock,
    startCitation,
    sendMessage,

    selectionBlock,
    startSelection,

    setSelectedMessagesCounter

  }
}